<template>
  <div id="card" class="professional-voting-description">
    <v-card class="voting-modal" elevation="12">
      <!-- Professional Header -->
      <v-card-title class="professional-header pa-0">
        <div class="header-content">
          <div class="header-left">
            <div class="icon-section">
              <v-icon size="28" color="white">mdi-vote</v-icon>
            </div>
            <div class="title-section">
              <h2 class="modal-title">Voting Description</h2>
              <p class="modal-subtitle">Complete voting information and guidelines</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon large color="white" class="close-btn" @click="closePrompt">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>

      <!-- Professional Content Area -->
      <v-card-text class="professional-content pa-0">
        <div class="content-container">
          <!-- Main Description Section -->
          <div class="description-section">
            <div class="section-header">
              <v-icon color="#1976d2" class="mr-3">mdi-information-outline</v-icon>
              <span class="section-title">Voting Guidelines & Information</span>
            </div>

            <div class="description-content">
              <div class="content-wrapper" v-html="recordData.VotingDescription"></div>
            </div>
          </div>

          <!-- Professional Action Section -->
          <div class="action-section">
            <div class="action-wrapper">
              <v-btn color="#1976d2" elevation="2" rounded large class="action-btn understand-btn" @click="closePrompt">
                <v-icon left>mdi-check-circle</v-icon>
                I Understand
              </v-btn>
              <v-btn outlined color="#666" elevation="0" rounded large class="action-btn cancel-btn ml-3"
                @click="closePrompt">
                <v-icon left>mdi-close</v-icon>
                Close
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      ResultFlag: false,
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.ResultFlag);
    },
    beforeMount() {
      this.refreshPageData();
    },
  },
};
</script>

<style lang="scss" scoped>
.professional-voting-description {
  .voting-modal {
    border-radius: 16px !important;
    overflow: hidden;
    max-width: 900px;
    width: 100%;
    margin: auto;
    background: #ffffff;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;

    // Professional Header Styles
    .professional-header {
      background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
      color: white;
      border-radius: 0 !important;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat;
        opacity: 0.1;
      }

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2rem;
        position: relative;
        z-index: 1;

        .header-left {
          display: flex;
          align-items: center;
          flex: 1;

          .icon-section {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            width: 56px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 1.5rem;
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
          }

          .title-section {
            .modal-title {
              font-size: 1.75rem;
              font-weight: 700;
              margin: 0 0 0.25rem 0;
              color: white;
              font-family: 'Roboto', sans-serif;
              line-height: 1.2;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }

            .modal-subtitle {
              font-size: 1rem;
              color: rgba(255, 255, 255, 0.9);
              margin: 0;
              font-weight: 400;
              opacity: 0.95;
            }
          }
        }

        .header-actions {
          .close-btn {
            background: rgba(255, 255, 255, 0.2) !important;
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            transition: all 0.3s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.3) !important;
              transform: rotate(90deg);
            }
          }
        }
      }
    }

    // Professional Content Styles
    .professional-content {
      .content-container {
        padding: 0;

        .description-section {
          padding: 2rem;
          border-bottom: 1px solid #f0f2f5;

          .section-header {
            display: flex;
            align-items: center;
            margin-bottom: 1.5rem;
            padding-bottom: 1rem;
            border-bottom: 2px solid #f8f9fa;

            .section-title {
              font-size: 1.25rem;
              font-weight: 600;
              color: #2c3e50;
              font-family: 'Roboto', sans-serif;
            }
          }

          .description-content {
            .content-wrapper {
              background: #f8fafc;
              border: 1px solid #e2e8f0;
              border-radius: 12px;
              padding: 2rem;
              line-height: 1.8;
              font-size: 1rem;
              color: #374151;
              position: relative;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 4px;
                height: 100%;
                background: linear-gradient(to bottom, #1976d2, #1565c0);
                border-radius: 2px 0 0 2px;
              }

              // Enhanced typography for the voting description content
              ::v-deep {

                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                  color: #2c3e50 !important;
                  font-weight: 600 !important;
                  margin: 1.5rem 0 1rem 0 !important;
                  font-family: 'Roboto', sans-serif !important;
                  line-height: 1.4 !important;
                }

                h1 {
                  font-size: 1.75rem !important;
                }

                h2 {
                  font-size: 1.5rem !important;
                }

                h3 {
                  font-size: 1.3rem !important;
                }

                h4 {
                  font-size: 1.2rem !important;
                }

                h5 {
                  font-size: 1.1rem !important;
                }

                h6 {
                  font-size: 1rem !important;
                }

                p {
                  margin: 1rem 0 !important;
                  line-height: 1.8 !important;
                  color: #374151 !important;
                  font-size: 1rem !important;
                }

                ul,
                ol {
                  margin: 1rem 0 1rem 1.5rem !important;

                  li {
                    margin: 0.5rem 0 !important;
                    line-height: 1.6 !important;
                    color: #374151 !important;
                  }
                }

                strong,
                b {
                  color: #1976d2 !important;
                  font-weight: 600 !important;
                }

                em,
                i {
                  color: #666 !important;
                  font-style: italic !important;
                }

                blockquote {
                  border-left: 4px solid #1976d2 !important;
                  padding-left: 1rem !important;
                  margin: 1.5rem 0 !important;
                  background: #f0f8ff !important;
                  padding: 1rem 1rem 1rem 2rem !important;
                  border-radius: 0 8px 8px 0 !important;
                  font-style: italic !important;
                }

                a {
                  color: #1976d2 !important;
                  text-decoration: none !important;
                  font-weight: 500 !important;

                  &:hover {
                    text-decoration: underline !important;
                    color: #1565c0 !important;
                  }
                }

                table {
                  width: 100% !important;
                  border-collapse: collapse !important;
                  margin: 1.5rem 0 !important;
                  background: white !important;
                  border-radius: 8px !important;
                  overflow: hidden !important;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;

                  th,
                  td {
                    padding: 12px 16px !important;
                    text-align: left !important;
                    border-bottom: 1px solid #e2e8f0 !important;
                  }

                  th {
                    background: #f8fafc !important;
                    color: #374151 !important;
                    font-weight: 600 !important;
                  }

                  tr:hover {
                    background: #f8fafc !important;
                  }
                }

                code {
                  background: #f1f5f9 !important;
                  padding: 2px 6px !important;
                  border-radius: 4px !important;
                  font-family: 'Monaco', 'Menlo', monospace !important;
                  font-size: 0.9rem !important;
                  color: #1976d2 !important;
                }
              }
            }
          }
        }

        .action-section {
          padding: 2rem;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-top: 1px solid #e9ecef;

          .action-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;

            .action-btn {
              font-weight: 600 !important;
              text-transform: none !important;
              letter-spacing: 0.5px !important;
              padding: 0 32px !important;
              height: 48px !important;
              font-size: 1rem !important;
              border-radius: 24px !important;
              transition: all 0.3s ease !important;
              font-family: 'Roboto', sans-serif !important;

              &.understand-btn {
                background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
                box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3) !important;

                &:hover {
                  transform: translateY(-2px) !important;
                  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4) !important;
                }
              }

              &.cancel-btn {
                border: 2px solid #e2e8f0 !important;
                color: #64748b !important;

                &:hover {
                  border-color: #cbd5e1 !important;
                  background: #f8fafc !important;
                  transform: translateY(-1px) !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

// Responsive Design
@media (max-width: 768px) {
  .professional-voting-description {
    .voting-modal {
      margin: 1rem;
      max-width: calc(100vw - 2rem);

      .professional-header {
        .header-content {
          padding: 1.5rem;

          .header-left {
            .icon-section {
              width: 48px;
              height: 48px;
              margin-right: 1rem;
            }

            .title-section {
              .modal-title {
                font-size: 1.5rem;
              }

              .modal-subtitle {
                font-size: 0.9rem;
              }
            }
          }
        }
      }

      .professional-content {
        .content-container {
          .description-section {
            padding: 1.5rem;

            .description-content {
              .content-wrapper {
                padding: 1.5rem;
                font-size: 0.95rem;
              }
            }
          }

          .action-section {
            padding: 1.5rem;

            .action-wrapper {
              flex-direction: column;
              gap: 12px;

              .action-btn {
                width: 100%;
                max-width: 280px;

                &.cancel-btn {
                  margin-left: 0 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .professional-voting-description {
    .voting-modal {
      margin: 0.5rem;

      .professional-header {
        .header-content {
          padding: 1rem;

          .header-left {
            .icon-section {
              width: 40px;
              height: 40px;
              margin-right: 0.75rem;
            }

            .title-section {
              .modal-title {
                font-size: 1.25rem;
              }

              .modal-subtitle {
                font-size: 0.85rem;
              }
            }
          }
        }
      }

      .professional-content {
        .content-container {
          .description-section {
            padding: 1rem;

            .section-header {
              .section-title {
                font-size: 1.1rem;
              }
            }

            .description-content {
              .content-wrapper {
                padding: 1rem;
                font-size: 0.9rem;
                line-height: 1.7;
              }
            }
          }

          .action-section {
            padding: 1rem;
          }
        }
      }
    }
  }
}
</style>